import { render, staticRenderFns } from "./CusButton.vue?vue&type=template&id=7bf46987&scoped=true"
import script from "./CusButton.vue?vue&type=script&lang=js"
export * from "./CusButton.vue?vue&type=script&lang=js"
import style0 from "./CusButton.vue?vue&type=style&index=0&id=7bf46987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf46987",
  null
  
)

export default component.exports